import React, { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Stores from "PersonaRoutes/Stores";
import AccessStores from "PersonaRoutes/AccessStores";
import StoreProfile from "PersonaRoutes/StoreProfile";
import AddUsersToStore from "PersonaRoutes/AddUsersToStore";
import Users from "PersonaRoutes/Users";
import AddUsers from "PersonaRoutes/AddUsers";
import UserProfile from "PersonaRoutes/UserProfile";
import AddStoresToUser from "PersonaRoutes/AddStoresToUser";
import ModifyUserPermissions from "PersonaRoutes/ModifyUserPermissions";
import { connect } from 'react-redux';
import { isValidToken } from '../../shared/utils/HelperFunctions';
import { useAppState } from 'shared/AppState/app-state';

const PersonaRoutes = () => {
  const [ appState ] = useAppState();
  const { personaToken } = appState;

  // Check auth FIRST, before rendering any routes
  if (!isValidToken(personaToken)) {
    return <Navigate to="/login" replace />;
  }

  return (
    <Routes>
      <Route path="AccessStores" element={<AccessStores />} />
      <Route path="Stores" element={<Stores />} />
      <Route path="Stores/:storeId" element={<StoreProfile />} />
      <Route path="Stores/:storeId/users/add" element={<AddUsersToStore />} />
      <Route path="Users" element={<Users />} />
      <Route path="Users/add" element={<AddUsers />} />
      <Route path="Users/:userId" element={<UserProfile />} />
      <Route path="Users/:userId/stores/add" element={<AddStoresToUser />} />
      <Route path="Users/:userId/Stores/:storeId/edit" element={<ModifyUserPermissions />} />
    </Routes>
  );
};

export default PersonaRoutes;
